import { StatusRetirada } from './../../../core/enums/status-retirada.enum';

export class RetiradaUtil {

  static getCssClassForStatusRetirada(statusRetirada: StatusRetirada) {
    let cssClass = '';
    switch (statusRetirada) {
      case StatusRetirada.APROVADA:
        cssClass = 'tag tag-success lista-tag';
        break;
      case StatusRetirada.REPROVADA:
        cssClass = 'tag tag-danger lista-tag';
        break;
      case StatusRetirada.RETIRADA:
        cssClass = 'tag tag-info lista-tag';
        break;
      case StatusRetirada.CANCELADA:
        cssClass = 'tag tag-warning lista-tag';
        break;
      default:
        cssClass = 'tag lista-tag'
        break;
    }

    return cssClass;
  }

}
